import React from "react";
import useGlobalHook from "use-global-hook";
import * as actions from "../Actions/ReconciliationActions";


const initialState = {
    status: 200,
    isLoading: false,
    isLoadingResult: false, 
    message: "",
    header: {},
    reconciliations: [],
    reconciliation: {},
    reconciliationSummary: {},
    reconciliationFailed: [],
    lastPage: false,
};

const ReconciliationStore = useGlobalHook(React, initialState, actions);

export default ReconciliationStore;
